import { render, staticRenderFns } from "./ProjectStaffManage.vue?vue&type=template&id=518f71bf&scoped=true&"
import script from "./ProjectStaffManage.vue?vue&type=script&lang=js&"
export * from "./ProjectStaffManage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStaffManage.vue?vue&type=style&index=0&id=518f71bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518f71bf",
  null
  
)

export default component.exports